// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__eNJMh","main":"Layout_main__16FFn"};